import React from 'react';
import InfoDialog from '../../../components/shared/InfoDialog';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { API_USERS } from '../../../api/users';
import useToast from '../../../hooks/useToast';
import { setDeleteUser } from '../../../store/apps/usersSlice';
import { useDispatch } from 'react-redux';
import { dispatchCusEvent } from '../../../utils';
import { ClearChosenListUserTable } from '../users/UserTable';

export default function DeleteAccount({
  open,
  closeModal,
  user = {},
  userIdList = [],
  setChosenList
}) {
  const { t } = useTranslation();
  const { successToast } = useToast();
  const dispatch = useDispatch();

  const onDeleteClick = () => {
    const deleteList = userIdList;
    if (user.userId) deleteList.push(user.userId);

    // console.log('deleteList', deleteList);

    API_USERS.info
      .delete({ userList: deleteList })
      .then((e) => {
        successToast('Successfully removed');
        dispatch(setDeleteUser(deleteList));
        setChosenList?.([]);
        dispatchCusEvent(ClearChosenListUserTable);
        closeModal();
      })
      .catch(console.error);
  };

  const titleText = user?.login
    ? `${t('Delete account')} ${user.login} ?`
    : t('Delete x accounts', { count: userIdList.length });

  return (
    <InfoDialog
      open={open}
      onClose={closeModal}
      saveText="Delete"
      title={'Deleting accounts'}
      maxWidth="xs"
      onSaveClick={onDeleteClick}>
      <Stack gap={1}>
        <Typography fontSize={16} fontWeight={600} color="textSecondary">
          {titleText}
        </Typography>
      </Stack>
    </InfoDialog>
  );
}
